import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { HistoryRouter } from "redux-first-history/rr6";
import { reduxHistory } from "./store/configureStore";
import AppRoutes from "./routes";
import store from "./store/configureStore";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import "./style.css";
import "./styles/themeTokens.css"; // TTS redesign — CSS variable tokens (light/dark)
import "./styles/tailwind.css";   // TTS redesign — tokens + brand fonts
import "./styles/swal-v2.css";    // TTS redesign — Swal brand skin (layered after the v1 MUI swal CSS)
import "./styles/datepicker-v2.css"; // TTS redesign — MUI DatePicker input + calendar popup brand skin
import { useAppTheme } from "./theme";
import { applyThemeAttribute, getThemeMode, resolveThemeMode } from "./utils/themeMode";
import { applyFontScale, getFontScale } from "./utils/fontScale";
import ErrorBoundary from "./components/ErrorBoundary";

// Apply the persisted theme to <html> BEFORE React mounts so the
// page paints in the correct mode on first frame instead of flashing
// light → dark. The useThemeMode hook keeps it in sync afterwards.
applyThemeAttribute(resolveThemeMode(getThemeMode()));

// Same idea for the persisted text-size (UI zoom on #root) — apply it up
// front so the page renders at the chosen scale; useFontScale keeps it
// in sync afterwards.
applyFontScale(getFontScale());

function ThemedApp() {
  const theme = useAppTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <HistoryRouter history={reduxHistory}>
          <AppRoutes />
        </HistoryRouter>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <ThemedApp />
  </Provider>
);
